import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function ProductCTA() {
  return (
    <section className="py-16 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Need Expert Fire Safety Consultation?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Our certified engineers are ready to help you design the perfect fire protection system 
            for your building. Get a customized quote today.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button variant="primary" className="bg-red-600 hover:bg-red-700">
                <i className="ri-message-3-line mr-2"></i>
                Get Free Consultation
              </Button>
            </Link>
            <a 
              href="https://wa.me/97455544093"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button variant="outline" className="border-white text-white hover:bg-white hover:text-gray-900">
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp Us
              </Button>
            </a>
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-white text-2xl"></i>
              </div>
              <h3 className="font-semibold text-white mb-2">24/7 Support</h3>
              <p className="text-gray-400 text-sm">Emergency maintenance and support services</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <h3 className="font-semibold text-white mb-2">QCDD Certified</h3>
              <p className="text-gray-400 text-sm">All products meet Qatar safety standards</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-tools-line text-white text-2xl"></i>
              </div>
              <h3 className="font-semibold text-white mb-2">Expert Installation</h3>
              <p className="text-gray-400 text-sm">Professional installation and commissioning</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}